const CustomizerProductLookup = {
  'le-duo-magnifique-custom': {
    boxAttribute: 'material Box',
    attributes: ['FirstSymbol', 'SecondSymbol'],
    productType: 'core',
    renderType: '2d',
  },
  'grandiose-custom': {
    boxAttribute: 'material Box G',
    attributes: ['Symbol_1_Grandiose', 'Symbol_2_Grandiose', 'Symbol_3_Grandiose', 'Symbol_4_Grandiose', 'Symbol_5_Grandiose'],
    productType: 'core',
    renderType: '2d',
  },
  'large-square-custom': {
    boxAttribute: 'material Box LS',
    attributes: ['Symbol_1_Large_Square'],
    productType: 'core',
    renderType: '2d',
  },
  'large-round-custom': {
    boxAttribute: 'material Box LR',
    attributes: ['Symbol_1_Large_Round'],
    productType: 'core',
    renderType: '2d',
  },
  'small-square-custom': {
    boxAttribute: 'material Box SS',
    attributes: ['Symbol_1_Small Square'],
    productType: 'core',
    renderType: '2d',
  },
  'fleur-frame-custom': {
    boxAttribute: '',
    attributes: [],
    productType: 'frame',
    renderType: 'vray',
  },
  'jardin-amour-fleur-frame-custom': {
    boxAttribute: '',
    attributes: [],
    productType: 'frame',
    renderType: 'vray',
  },
  'sunstone-garden-fleur-frame-custom': {
    boxAttribute: '',
    attributes: [],
    productType: 'frame',
    renderType: 'vray',
  },
  'mini-fleur-frame-custom': {
    boxAttribute: '',
    attributes: [],
    productType: 'frame',
    renderType: 'vray',
  },
  'small-square-white-classic-photo-box': {
    boxAttribute: '',
    attributes: [],
    productType: 'frame',
    renderType: 'vray',
  },
};

export default CustomizerProductLookup;
